import { useQuery } from '@tanstack/react-query';
import type { LeadListResponse, ContactListResponse } from '@troia-v3/types';
import { campaignsService } from '../services/campaignsService';

interface AudienceQueryOptions {
  page: number;
  limit: number;
  search: string;
  channelId?: string;
  filters: Record<string, unknown>;
}

export const useCampaignAudience = (
  type: 'leads' | 'contacts',
  options: AudienceQueryOptions
) => {
  const leadsQuery = useQuery<LeadListResponse>({
    queryKey: ['campaign-audience', 'leads', options],
    queryFn: () => campaignsService.getAudienceLeads(options),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
    enabled: type === 'leads',
  });

  const contactsQuery = useQuery<ContactListResponse>({
    queryKey: ['campaign-audience', 'contacts', options],
    queryFn: () => campaignsService.getAudienceContacts(options),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
    enabled: type === 'contacts',
  });

  return type === 'leads' ? leadsQuery : contactsQuery;
};

export const useCampaignAudienceTags = () => {
  return useQuery({
    queryKey: ['campaign-audience-tags'],
    queryFn: () => campaignsService.getAudienceTags(),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
